import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const NotFound = () => {
    const navigate = useNavigate();

    // Redirect to homepage after 5 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/');
        }, 5000);
        return () => clearTimeout(timer);  // Cleanup the timer
    }, [navigate]);

    return (
        <div className="w-screen h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-100 via-white to-blue-200 text-center font-poppins relative mb={20px}">
            {/* SEO for page not found */}
            <Helmet>
                <title>Page Not Found | Refyn Data</title>
                <meta name="description" content="Contact Us at 626-378-4849 or email us at hr@refyndata.com for inquiries and support." />
                <meta name="keywords" content="IT staffing agency, IT recruitment agency, contact us, Refyn Data" />
                <meta property="og:title" content="Contact Us | Refyn Data" />
                <meta property="og:description" content="Contact Us at 626-378-4849 or email us at hr@refyndata.com for inquiries and support." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.refyndata.com/contact-us" />
                <meta property="og:image" content="https://www.refyndata.com/center.png" />
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:title" content="Contact Us | Refyn Data" />
                <meta property="twitter:description" content="Contact Us at 626-378-4849 or email us at hr@refyndata.com for inquiries and support." />
                <meta property="twitter:image" content="https://www.refyndata.com/center.png" />
            </Helmet>

            <div className="text-[#022452] mb-5">
                <h1 className="text-5xl font-bold mb-2 animate-bounce">Refyn Data</h1>
                <h4 className="text-xl font-semibold">We Redefine Your World</h4>
            </div>

            <div className="text-center space-y-4 mt-8">
                <h2 className="text-6xl font-extrabold text-[#022452]">404</h2>
                <p className="text-2xl text-gray-700">Oops! Page Not Found</p>
                <h6 className="text-lg text-gray-500">The page you are looking for doesn't exist.</h6>
            </div>

            <div className="mt-10">
                <Link to="/" className="inline-block px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition-colors">
                 <h5>Go Back to Home</h5>   
                </Link>
            </div>

            <h6 className="mt-4 text-gray-500 text-sm">Redirecting to homepage in 5 seconds...</h6>

            {/* Background Animation */}
            <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-blue-400 to-transparent opacity-20 animate-pulse" />
        </div>
    );
}

export default NotFound;
